// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"74":"737350bd","141":"91bf5bf5","240":"ed5fdf10","517":"22ce9655","719":"22ce9655","873":"22ce9655","906":"737350bd"}[chunkId] + ".chunk.css";
};